<template>
  <div :class="['data-unpack-module', {'is-inline': inline}]"
       v-loading="module.loading"
       element-loading-text="配置加载中，请稍等...">
    <div class="module-step" v-if="step === 'module'">
      <template v-if="module.config">
        <div v-if="module.config.instruction"
             class="module-file-download">
          <div class="instruction">
            <span>{{module.config.instruction}}</span>
          </div>
        </div>
        <el-upload ref="dataUnpackModuleUpload"
                   :class="['data-unpack-file-upload', {'upload-ready': !!module.readyFile}]"
                   drag
                   :accept="supportFileType.length ? supportFileType.join(',') : ''"
                   :show-file-list="false"
                   :on-change="handleFileChange"
                   :before-upload="beforeFileUpload"
                   :on-progress="handleFileUploadProgress"
                   :on-success="handleFileUploadSuccess"
                   :on-error="handleFileUploadError"
                   name="uploadFile"
                   :http-request="options => httpRequest(options, true)"
                   :action="uploadFileUrl"
                   :auto-upload="false">
          <i class="el-upload__icon iconfont icon-zip1"></i>
          <template v-if="module.readyFile">
            <div class="el-upload__text">{{module.readyFile.name}}</div>
            <div class="el-upload__tip">
              {{module.readyFile.size | formatFileSize}}
            </div>
            <div class="el-upload__btn">
              <el-button type="default">重新选择</el-button>
            </div>
          </template>
          <template v-else>
            <div class="el-upload__text">将文件拖拽到此区域</div>
            <div class="el-upload__tip">
              只能上传<span class="upload-type">{{supportFileType.length ? supportFileType.join('、') : '未指定'}}</span>文件，且不超过{{maxUploadFileSize | formatFileSize}}
            </div>
            <div class="el-upload__btn">
              <el-button type="default">{{ uploadText }}</el-button>
            </div>
          </template>
        </el-upload>
      </template>
    </div>
    <div class="parser-step" v-else-if="step === 'parser'"
         v-loading="parser.loading"
         element-loading-text="数据加载中，请稍等...">
      <template v-if="parser.unpackData">
        <template v-if="state.unpackComplete && dataUnpack.resultMsg">
          <div class="parser-result">
            <div class="state-info">
              <i class="el-icon--state" :class="{true: 'el-icon-success', false: 'el-icon-warning'}[!dataUnpack.ignoreEntries.length]"></i>
            </div>
            <div class="result-msg">
              <div class="content">{{dataUnpack.resultMsg}}</div>
              <div v-if="dataUnpack.ignoreEntries.length"
                   class="ignore-tip">忽略{{dataUnpack.ignoreEntries.length}}个文件条目</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="parser-detail">
            <div class="upload-detail">
              <span class="upload-info">
                <a v-if="module.uploadFile.link"
                   class="theme-text-hover"
                   title="上传源文件"
                   :href="$contextPath(module.uploadFile.link)"
                   target="_blank">
                  <i class="el-icon-document"></i>
                </a>
                <span>本次共上传了<span class="entry-count">{{uploadDataCount}}</span>个条目</span>
              </span>
              <span class="ignore-info" v-if="dataUnpack.ignoreEntries && dataUnpack.ignoreEntries.length">
                已忽略<span class="entry-count">{{dataUnpack.ignoreEntries.length}}</span>个条目
              </span>
            </div>
            <div class="unpack-detail">
              <div class="unpack-detail-item" v-if="dataUnpack.unpacking && uploadDataCount > 0">
                <el-progress :text-inside="true" :stroke-width="16" :percentage="Math.round((dataUnpack.entryIndex + 1) * 100 / uploadDataCount)"></el-progress>
              </div>
            </div>
          </div>
          <div class="ignore-data">
            <div v-if="dataUnpack.ignoreEntries && dataUnpack.ignoreEntries.length"
                 class="ignore-data-list">
              <AppScrollbar style="height: 100%">
                <div class="ignore-cont">
                  <ul>
                    <li v-for="(ignoreEntry, index) in dataUnpack.ignoreEntries"
                        :key="'ignore-entry-' + index"
                        class="theme-light-bg-hover">
                      <span class="entry-msg">已忽略：<span class="entry-text">{{ignoreEntry}}</span></span>
                      <span class="error-msg">{{dataUnpack.errorInfos[index]}}</span>
                    </li>
                  </ul>
                </div>
              </AppScrollbar>
            </div>
            <div class="empty" v-else>
              <i class="el-icon--tip el-icon-s-comment"></i>
              <span v-if="dataUnpack.unpacking">已忽略的条目为空</span>
              <span v-else>{{ startupHint }}</span>
            </div>
          </div>
        </template>
      </template>
      <template v-else-if="!parser.loading">
        <Hint v-if="parser.errorMsg"
              type="error"
              class="error-msg">
          <span>{{parser.errorMsg}}</span>
        </Hint>
      </template>
    </div>
    <div class="footer clearfix">
      <div v-if="$slots.external"
           class="external-group">
        <slot name="external"></slot>
      </div>
      <div class="internal-group">
        <div class="button-group">
          <template v-if="step === 'module'">
            <el-button type="primary" size="mini" :disabled="module.uploadFile.uploading" v-if="module.config" @click="startUploadFile">{{module.uploadFile.uploading ? `上传中...${module.uploadFile.percent}%` : '开始上传'}}</el-button>
          </template>
          <template v-else-if="step === 'parser'">
            <template v-if="dataUnpack.unpacking">
              <el-button type="danger" plain size="mini" :disabled="state.isInterrupting" v-if="dataUnpack.entryIndex < uploadDataCount - 1" @click="cancelDataUnpack">取消数据处理</el-button>
            </template>
            <template v-else>
              <el-button type="warning" plain size="mini" @click="step = 'module'">重新{{ uploadText }}</el-button>
              <el-button type="primary" size="mini" v-if="parser.unpackData && !state.unpackComplete" @click="confirmUnpackData">{{state.isUnpacked ? '重新处理数据' : '确认处理数据'}}</el-button>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Support from '../../mixins/support'
import ElUpload from '../../mixins/upload/ElUpload'
import AppScrollbar from '../elements/AppScrollbar'
import Hint from './Hint'
export default {
  mixins: [Support, ElUpload],
  name: 'DataUnpackModule',
  components: {
    AppScrollbar,
    Hint
  },
  props: {
    uploadText: {
      type: String,
      default: '上传文件'
    },
    startupHint: {
      type: String,
      default: '点击处理按钮开始'
    },
    unpackUrl: {
      required: true,
      type: String
    },
    preHandleParams: {
      type: Function
    },
    extraParams: {
      type: Object,
      required: false
    },
    preHandleVerify: {
      type: Function
    },
    inline: Boolean
  },
  data () {
    return {
      isAlive: true,
      pollDelay: 500,
      step: 'module',
      module: {
        loading: false,
        config: null,
        readyFile: null,
        uploadFile: {
          uploading: false,
          percent: 0,
          link: null,
          defaultMaxSize: 100 * 1024 * 1024
        }
      },
      parser: {
        loading: false,
        unpackData: null,
        errorMsg: ''
      },
      dataUnpack: {
        unpacking: false,
        entryIndex: -1,
        ignoreEntries: [],
        errorInfos: [],
        resultMsg: null
      },
      state: {
        isInterrupting: false,
        isUnpacked: false,
        unpackComplete: false
      }
    }
  },
  computed: {
    supportFileType: function () {
      let config = this.module.config
      if (config) {
        return config.supportFileType || []
      }
      return []
    },
    maxUploadFileSize: function () {
      let config = this.module.config
      if (config) {
        return config.maxFileSize || this.module.uploadFile.defaultMaxSize
      }
      return this.module.uploadFile.defaultMaxSize
    },
    uploadFileUrl: function () {
      let query = this.$qs.stringify(this.getActionParams(), {
        arrayFormat: 'repeat'
      })
      let uploadUrl = this.$contextPath(this.getActionUrl('Upload'))
      if (query) {
        if (uploadUrl.includes('?')) {
          return uploadUrl + '&' + query
        } else {
          return uploadUrl + '?' + query
        }
      } else {
        return uploadUrl
      }
    },
    uploadDataCount: function () {
      if (this.parser.unpackData) {
        return this.parser.unpackData.dataCount || 0
      } else {
        return 0
      }
    }
  },
  methods: {
    getActionUrl (action) {
      let unpackUrl = this.unpackUrl
      let quotIndex = unpackUrl.indexOf('?')
      if (quotIndex > 0) {
        return `${unpackUrl.substring(0, quotIndex)}${action}${unpackUrl.substring(quotIndex)}`
      } else {
        return `${unpackUrl}${action}`
      }
    },
    getActionParams () {
      if (this.preHandleParams) {
        return this.$extend(this.preHandleParams(), this.extraParams)
      } else {
        return this.extraParams || {}
      }
    },
    // 校验文件
    validateFile (file, showMsg) {
      let filename = file.name
      let index = filename.lastIndexOf('.')
      if (index > 0) {
        let suffix = filename.substring(index).toLowerCase()
        if (!this.supportFileType.includes(suffix)) {
          if (showMsg) {
            this.$message.error('上传的文件格式不合法')
          }
          return false
        }
      } else {
        if (showMsg) {
          this.$message.error('上传的文件格式不合法')
        }
        return false
      }
      let isLt = file.size <= this.maxUploadFileSize
      if (isLt) {
        return true
      } else {
        if (showMsg) {
          this.$message.error('上传的文件大小超过限制')
        }
        return false
      }
    },
    // 文件准备
    handleFileChange (file, fileList) {
      if (file.status === 'ready') {
        if (this.validateFile(file, true)) {
          this.module.readyFile = file
          let dataUnpackModuleUpload = this.$refs['dataUnpackModuleUpload']
          if (dataUnpackModuleUpload) {
            fileList.forEach(f => {
              if (f !== file) {
                dataUnpackModuleUpload.handleRemove(f)
              }
            })
          }
        } else {
          this.resetModuleData()
        }
      }
    },
    // 上传前验证
    beforeFileUpload (file) {
      if (this.validateFile(file, true)) {
        this.module.uploadFile.uploading = true
        this.module.uploadFile.percent = 0
        return true
      } else {
        return false
      }
    },
    // 上传进度
    handleFileUploadProgress (event) {
      this.module.uploadFile.percent = Math.round(event.percent)
    },
    // 上传成功
    handleFileUploadSuccess (res) {
      this.module.uploadFile.uploading = false
      if (res['responseCode'] === 'SUCCESS') {
        this.module.uploadFile.link = res['fileUrl']
        this.step = 'parser'
      } else {
        this.$message.error(res.message || '获取返回信息失败')
      }
    },
    // 上传错误
    handleFileUploadError () {
      this.module.uploadFile.uploading = false
      this.$message.error('文件上传失败')
      this.$nextTick(() => this.resetModuleData())
    },
    // 上传文件
    startUploadFile () {
      let preHandleVerify = this.preHandleVerify
      if (preHandleVerify && !preHandleVerify()) {
        return
      }
      if (!this.module.readyFile) {
        this.$message.warning(`请先选择${this.uploadText}`)
        return
      }
      let dataUnpackModuleUpload = this.$refs['dataUnpackModuleUpload']
      if (dataUnpackModuleUpload) {
        dataUnpackModuleUpload.submit()
      } else {
        this.$notify({
          title: '操作错误',
          message: '请等待组件初始化完毕',
          type: 'error'
        })
      }
    },
    // 加载拆包配置
    loadUnpackConfigData () {
      this.module.loading = true
      let params = this.$extend(this.getActionParams(), this.$attrs)
      this.$ajax({
        url: this.unpackUrl,
        method: 'post',
        data: this.$qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.module.config = response.data['config']
              // 是否包含场景信息
              let taskSceneData = response.data['taskSceneData']
              if (taskSceneData) {
                this.$confirm('当前任务正在进行，是否进入?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.module.uploadFile.link = taskSceneData['fileUrl']
                  this.parser.unpackData = taskSceneData['parserData']
                  this.step = 'parser'
                  this.dataUnpack.unpacking = true
                  // 进入并查看状态
                  this.loadDataUnpackState()
                }).catch(() => {})
              }
              break
            }
            default: {
              this.$message({
                message: response.data['message'],
                type: 'warning',
                center: true
              })
              break
            }
          }
        }
      }, () => {
        this.$message.error({
          message: '请求发送失败，请稍候重试',
          center: true
        })
      }).finally(() => {
        this.module.loading = false
      })
    },
    // 加载解析数据
    loadImportParserData () {
      this.parser.loading = true
      let params = this.$extend({
        parserPath: this.module.uploadFile.link
      }, this.getActionParams(), this.$attrs)
      this.$ajax({
        url: this.getActionUrl('Parser'),
        method: 'post',
        data: this.$qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.parser.unpackData = response.data['parserData']
              break
            }
            default: {
              let errorMsg = response.data['message'] || '解析文件数据失败'
              this.$message({
                message: errorMsg,
                type: 'warning',
                center: true
              })
              this.parser.errorMsg = errorMsg
              break
            }
          }
        }
      }, () => {
        let errorMsg = '请求发送失败，请稍候重试'
        this.$message.error({
          message: errorMsg,
          center: true
        })
        this.parser.errorMsg = errorMsg
      }).finally(() => {
        this.parser.loading = false
      })
    },
    // 确认拆包数据
    confirmUnpackData () {
      this.resetUnpackState()
      this.dataUnpack.unpacking = true
      this.state.isUnpacked = true
      let params = this.$extend({
        parserPath: this.module.uploadFile.link
      }, this.getActionParams(), this.$attrs)
      this.$ajax({
        url: this.getActionUrl('Unpack'),
        method: 'post',
        data: this.$qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.loadDataUnpackState()
              break
            }
            default: {
              this.$message({
                message: response.data['message'],
                type: 'warning',
                center: true
              })
              this.dataUnpack.unpacking = false
              break
            }
          }
        }
      }, () => {
        this.$message.error({
          message: '请求发送失败，请稍候重试',
          center: true
        })
        this.dataUnpack.unpacking = false
      })
    },
    // 获取任务执行状态
    loadDataUnpackState () {
      if (this.isAlive) {
        let params = this.$extend(this.getActionParams(), this.$attrs)
        this.$ajax({
          url: this.getActionUrl('State'),
          method: 'post',
          data: this.$qs.stringify(params, {
            arrayFormat: 'repeat'
          })
        }).then((response) => {
          if (response.data) {
            let taskState = response.data['taskState']
            if (taskState && taskState['state']) {
              // 刷新执行行数
              let stateInfo = taskState['stateInfo']
              if (stateInfo) {
                let entryIndex = stateInfo['entryIndex']
                if (typeof entryIndex === 'number') {
                  this.dataUnpack.entryIndex = entryIndex
                }
                let ignoreEntries = stateInfo['ignoreEntries']
                if (ignoreEntries) {
                  this.dataUnpack.ignoreEntries = ignoreEntries
                }
                let errorInfos = stateInfo['errorInfos']
                if (errorInfos) {
                  this.dataUnpack.errorInfos = errorInfos
                }
              }
              switch (taskState['state']) {
                case 'PREPARING':
                  // 准备状态
                  break
                case 'RUNNING':
                  // 运行状态
                  break
                case 'IGNORE_AWAIT':
                  this.$confirm(taskState['message'], '提示', {
                    confirmButtonText: '忽略全部',
                    cancelButtonText: '忽略本条',
                    type: 'warning',
                    closeOnClickModal: false,
                    distinguishCancelAndClose: true,
                    callback: action => {
                      switch (action) {
                        case 'confirm':
                          this.submitDataUnpackReply(true, true)
                          break
                        case 'cancel':
                          this.submitDataUnpackReply(true, false)
                          break
                        case 'close':
                          this.submitDataUnpackReply(false)
                          break
                      }
                    }
                  })
                  return
                case 'AWAIT':
                  this.$confirm(taskState['message'], '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    closeOnClickModal: false
                  }).then(() => {
                    this.submitDataUnpackReply(true)
                  }).catch(() => {
                    this.submitDataUnpackReply(false)
                  })
                  return
                case 'INTERRUPT':
                  this.$alert(taskState['message'], '操作中断', {
                    confirmButtonText: '确定',
                    type: 'warning',
                    callback: () => {
                      this.dataUnpack.unpacking = false
                    }
                  })
                  return
                case 'COMPLETE':
                  let confirmType = taskState['confirmType'] || 'success'
                  let resultMsg = taskState['message']
                  if (confirmType === 'success') {
                    this.dataUnpack.resultMsg = resultMsg
                    this.$emit('dataUnpackSuccess')
                  } else {
                    this.$alert(resultMsg, '执行结束', {
                      confirmButtonText: '确定',
                      type: confirmType
                    })
                  }
                  this.state.unpackComplete = true
                  this.dataUnpack.unpacking = false
                  return
                default:
                  return
              }
            } else {
              this.$alert('处理过程执行结束', '执行结束', {
                confirmButtonText: '确定',
                type: 'success',
                callback: () => {
                  this.dataUnpack.unpacking = false
                }
              })
            }
          }
          this.$nextTick(() => {
            setTimeout(() => {
              this.loadDataUnpackState()
            }, this.pollDelay)
          })
        }, () => {
          setTimeout(() => {
            this.loadDataUnpackState()
          }, this.pollDelay)
        })
      }
    },
    // 提交回复信息
    submitDataUnpackReply (isOk, isAll) {
      let params = this.$extend({
        replyType: isOk,
        ignoreAll: isAll
      }, this.getActionParams(), this.$attrs)
      this.$ajax({
        url: this.getActionUrl('Reply'),
        method: 'post',
        data: this.$qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        // 无需处理结果
      }, () => {
        this.$message.error({
          message: '请求发送失败，请稍候重试',
          center: true
        })
      }).finally(() => {
        this.loadDataUnpackState()
      })
    },
    // 取消数据拆包
    cancelDataUnpack () {
      this.state.isInterrupting = true
      let params = this.$extend(this.getActionParams(), this.$attrs)
      this.$ajax({
        url: this.getActionUrl('Interrupt'),
        method: 'post',
        data: this.$qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              // 不做处理
              break
            }
            default: {
              this.$message({
                message: response.data['message'],
                type: 'warning',
                center: true
              })
              break
            }
          }
        }
      }, () => {
        this.$message.error({
          message: '请求发送失败，请稍候重试',
          center: true
        })
      }).finally(() => {
        this.state.isInterrupting = false
      })
    },
    // 重置module数据
    resetModuleData () {
      this.module.readyFile = null
      this.module.uploadFile.link = null
      let dataUnpackModuleUpload = this.$refs['dataUnpackModuleUpload']
      if (dataUnpackModuleUpload) {
        dataUnpackModuleUpload.clearFiles()
      }
    },
    // 重置拆包状态
    resetUnpackState () {
      this.dataUnpack.entryIndex = -1
      this.dataUnpack.ignoreEntries = []
      this.dataUnpack.errorInfos = []
      this.dataUnpack.resultMsg = null
    },
    // 重置parser数据
    resetParserData () {
      this.parser.unpackData = null
      this.parser.errorMsg = ''
      this.dataUnpack.entryIndex = -1
      this.dataUnpack.ignoreEntries = []
      this.dataUnpack.errorInfos = []
      this.dataUnpack.resultMsg = null
      this.state.isUnpacked = false
      this.state.unpackComplete = false
    }
  },
  mounted () {
    this.loadUnpackConfigData()
  },
  destroyed () {
    this.isAlive = false
  },
  watch: {
    step: function (newValue) {
      if (newValue) {
        switch (newValue) {
          case 'module': {
            this.resetModuleData()
            break
          }
          case 'parser': {
            this.resetParserData()
            this.loadImportParserData()
            break
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @use "../../styles/color" as *;

  .data-unpack-module {
    height: 420px;
    display: flex;
    flex-direction: column;
    .module-step {
      flex: auto;
      display: flex;
      flex-direction: column;
      padding: 0 15px;
      box-sizing: border-box;
      .module-file-download {
        flex: none;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff3e9;
        border: 1px solid #fdd5b0;
        padding: 16px 20px;
        margin-top: 15px;
        &>.instruction {
          font-size: 12px;
          color: #e6a23c;
          line-height: 20px;
        }
      }
      .data-unpack-file-upload {
        flex: auto;
        display: flex;
        flex-direction: column;
        margin-top: 15px;
        &.upload-ready {
          .el-upload {
            .el-upload-dragger {
              .el-upload__icon {
                color: #61af44;
              }
            }
          }
        }
        .el-upload {
          flex: auto;
          display: flex;
          flex-direction: column;
          .el-upload-dragger {
            flex: auto;
            width: 100%;
            min-height: 260px;
            border-radius: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .el-upload__icon {
              margin-top: -10px;
              color: #dde5eb;
              font-size: 60px;
              width: auto;
            }
            .el-upload__text {
              font-size: 12px;
              line-height: 24px;
            }
            .el-upload__tip {
              margin-top: 8px;
              color: #909399;
              line-height: 20px;
              .upload-type {
                margin: 0 2px;
                color: $set-primary-color;
              }
            }
            .el-upload__btn {
              margin-top: 15px;
              .el-button {
                padding: 6px 12px;
                border-radius: 0;
              }
            }
          }
        }
      }
    }
    .parser-step {
      flex: auto;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      &>.parser-result {
        flex: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 15px 15px 0;
        background-color: #fff;
        overflow: hidden;
        &>.state-info {
          .el-icon--state {
            font-size: 54px;
            &.el-icon-success {
              color: $set-success-color;
            }
            &.el-icon-warning {
              color: $set-warning-color;
            }
          }
        }
        &>.result-msg {
          align-self: stretch;
          overflow: auto;
          margin-top: 15px;
          font-size: 14px;
          text-align: center;
          &>.content {
            white-space: pre-wrap;
          }
          &>.ignore-tip {
            margin-top: 8px;
            color: #909399;
            font-size: 12px;
          }
        }
      }
      &>.parser-detail {
        flex: none;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        padding: 10px 15px;
        &>.upload-detail {
          display: flex;
          align-items: center;
          &>.upload-info {
            a {
              margin-right: 2px;
              color: inherit;
              font-size: 13px;
              text-decoration: none;
              vertical-align: -1px;
            }
            .entry-count {
              margin: 0 2px;
              color: $set-primary-color;
            }
            &~.ignore-info {
              position: relative;
              padding-left: 10px;
              &:before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                width: 1px;
                height: 10px;
                margin-top: -4px;
                background-color: #c0c4cc;
              }
            }
          }
          &>.ignore-info {
            margin-left: 10px;
            color: #e6a23c;
            vertical-align: 1px;
            .entry-count {
              margin: 0 2px;
            }
          }
        }
        &>.unpack-detail {
          .unpack-detail-item {
            display: flex;
            align-items: center;
            .el-progress {
              &.el-progress--line {
                width: 150px;
                &>.el-progress-bar {
                  &>.el-progress-bar__outer {
                    border-radius: 0;
                    background-color: transparent;
                    &:after {
                      content: '';
                      position: absolute;
                      left: 0;
                      bottom: 0;
                      width: 100%;
                      height: 3px;
                      background-color: #ebeef5;
                    }
                    &>.el-progress-bar__inner {
                      border-radius: 0;
                      background-color: transparent;
                      &:after {
                        content: '';
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        height: 3px;
                        background-color: $set-primary-color;
                        z-index: 1;
                      }
                      &>.el-progress-bar__innerText {
                        margin: 0;
                        color: #303133;
                        transform: scale(.9) translate(5%, -30%);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      &>.ignore-data {
        flex: auto;
        position: relative;
        background-color: #fff;
        border: 1px solid #ebeef5;
        margin: 0 15px;
        box-sizing: border-box;
        &>.ignore-data-list {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          .ignore-cont {
            ul {
              list-style: none;
              margin: 0;
              padding: 5px 0;
              &>li {
                padding: 4px 12px;
                font-size: 12px;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                &>.entry-msg {
                  flex: none;
                  white-space: nowrap;
                  .entry-text {
                    color: #e6a23c;
                  }
                }
                &>.error-msg {
                  flex: auto;
                  margin-left: 10px;
                  color: $set-danger-color;
                  text-align: right;
                  &:before {
                    content: '\005b';
                    padding-right: 5px;
                  }
                  &:after {
                    content: '\005d';
                    padding-left: 5px;
                  }
                }
              }
            }
          }
        }
        &>.empty {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
          color: #909399;
          font-size: 12px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .el-icon--tip {
            margin-bottom: 5px;
            color: #ebeef5;
            font-size: 42px;
          }
        }
      }
      &>.error-msg {
        flex: auto;
        margin: 15px 15px 0;
        background-color: #fff;
      }
    }
    .footer {
      flex: none;
      display: flex;
      align-items: center;
      padding: 15px;
      &>.external-group {
        flex: none;
        margin-right: 10px;
        &~.internal-group {
          &>.button-group {
            text-align: right;
          }
        }
      }
      &>.internal-group {
        flex: auto;
        &>.button-group {
          text-align: center;
          .el-button {
            text-decoration: none;
            &+.el-button {
              margin-left: 8px;
            }
          }
        }
      }
    }
    &.is-inline {
      .module-step {
        padding-left: 0;
        padding-right: 0;
        &>.module-file-download {
          margin-top: 0;
        }
      }
      .parser-step {
        &>.parser-detail {
          padding-left: 0;
          padding-right: 0;
        }
        &>.ignore-data,
        &>.parser-result,
        &>.error-msg {
          margin-left: 0;
          margin-right: 0;
          border: 1px solid #ebeef5;
        }
      }
      .footer {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
</style>
